module.exports = __webpack_public_path__ + "img/image_31.6a17cb63.png";